__turbopack_context__.v({
  "logo": "Nav-module__9jTzVG__logo",
  "nav": "Nav-module__9jTzVG__nav",
  "navGroup": "Nav-module__9jTzVG__navGroup",
});
